import logo from '@/assets/logo.png'
import { APP_NAME } from '@/utils/constants'
import { useTitle } from 'ahooks'
import { Col, Layout, Row, Space } from 'antd'
import { Header } from 'antd/es/layout/layout'
import { memo } from 'react'
import { Outlet } from 'react-router-dom'
import HeaderMenu, { MenuItem } from '../../components/HeaderMenu'
import Notification from '../../components/Notification'
import UserAction from '../../components/UserAction'
import styles from './index.module.less'

const MENUS: MenuItem[] = [
  {
    path: '/home',
    title: 'Home'
  },
  {
    path: '/pricing',
    title: 'Pricing'
  }
]

export default memo(function HomeLayout() {
  useTitle(`${APP_NAME}`)

  return (
    <Layout className='layout' style={{ height: '100%' }}>
      <Header className={styles.header}>
        <Row className={'w100'} align={'middle'} justify={'space-between'}>
          <Col flex={'auto'}>
            <Row gutter={16}>
              <Col className='flex-col-center'>
                <img height={24} src={logo} alt='logo' />
              </Col>
              <Col flex={'auto'}>
                <HeaderMenu menus={MENUS} />
              </Col>
            </Row>
          </Col>
          <Col>
            <Space align='center' size={16}>
              {/* <GlobalSearch /> */}
              <Notification />
              <UserAction />
            </Space>
          </Col>
        </Row>
      </Header>

      <Layout.Content className={styles.content}>
        <div className={styles.contentChildren}>
          <Outlet />
        </div>
      </Layout.Content>
    </Layout>
  )
})
